<dx-popup width="30vw" height="100vh" [showTitle]="true" [title]="title" [(visible)]="visible" [animation]="{ 
    hide: { type: 'slideOut', direction: 'right', duration: 250 }, 
    show: {type: 'slideIn', direction: 'right', duration: 250 }
}" (onHidden)="onClose()" class="slide-panel">
    <dxo-position my="right top" at="right top">
    </dxo-position>
    <ng-content></ng-content>

</dx-popup>